/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../components/loading/loading.component';
import Notification from '../common/notification/notification.component';
import ConsentingJournalService from './consenting.journal.service';
import { generateIteratorKey as keygen } from '../../utils/helpers';
import { Grid, Col, Row, FormControl, ControlLabel, FormGroup } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import * as consts from '../../const.js';

class ConsentingJournalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      consentGid: this.props.consentGid,
      consentingGid: this.props.consentingGid,
      documentsMetadata: this.props.documentsMetadata,
      timezone: this.props.timezone
    };
  }

  createJournalDocumentSelectItems(documentsMetadata) {
    let options = [];
    options.push(
      <option {...keygen} value={consts.PARTICIPANT_DETAILS}>
        {consts.PARTICIPANT_DETAILS}
      </option>
    );
    if (documentsMetadata) {
      for (let document of documentsMetadata) {
        if (document.consentingGid) {
          options.push(
            <option {...keygen()} value={document.consentGid}>
              {document.consentName}, {consts.VERSION} {document.version} - {consts[document.status]}
            </option>
          );
        }
      }
    }
    return options;
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  onJournalDocumentSelectChanged(event) {
    let consentGid = event.target.value;
    let consentingGid = this.state.consentingGid;
    if (event.target.value === consts.PARTICIPANT_DETAILS) {
      this.props.fetchParticipantJournal(this.props.participantJourneyGid);
      this.setState({ consentGid });
      return;
    }

    for (let doc of this.state.documentsMetadata) {
      if (doc.consentGid === consentGid) {
        consentingGid = doc.consentingGid;
      }
    }

    this.props.journalDocumentSelectionChanged(consentingGid);
    this.setState({ consentGid, consentingGid });
  }

  onClick(event) {
    const { consentingGid, consentGid } = this.state;
    if (consentGid === consts.PARTICIPANT_DETAILS) {
      this.props.fetchParticipantJournalPDF(this.props.participantJourneyGid);
    } else {
      this.props.fetchJournalPdf(consentingGid);
    }
  }

  createDocumentGrid(documentsMetadata) {
    const { consentingGid, consentGid } = this.state;

    let downloadButton = null;
    if (consentingGid || consentGid === consts.PARTICIPANT_DETAILS) {
      downloadButton = (
        <div className="pull-right">
          <Button
            id="download-journal-button"
            theme="default large-button"
            handleClick={this.onClick.bind(this)}
            label={consts.DOWNLOAD}
          />
        </div>
      );
    }

    let notificationError = null;
    if (this.props.error) {
      notificationError = <Notification type="error" data={this.props.error} />;
    }

    return (
      <Grid id="consenting-details" fluid>
        <Row>
          <Col xs={10} className="consenting-details-col form-horizontal">
            <FormGroup>
              <Col xs={1}>
                <ControlLabel>{consts.JOURNAL}: </ControlLabel>
              </Col>
              <Col xs={10}>
                <FormControl
                  id="consenting-journal-document-selector"
                  required
                  componentClass="select"
                  value={this.state.consentGid}
                  onChange={this.onJournalDocumentSelectChanged.bind(this)}
                >
                  <option {...keygen}>{''}</option>
                  {this.createJournalDocumentSelectItems(documentsMetadata)}
                </FormControl>
              </Col>
            </FormGroup>
          </Col>
          <Col xs={2} className="consenting-download-col" id="consenting-journal-download">
            {downloadButton}
          </Col>
        </Row>
        <Row>{notificationError}</Row>
      </Grid>
    );
  }

  render() {
    let body = '';
    const { documentsMetadata } = this.props;

    if (this.state.consentGid) {
      if (this.props.isFetching) {
        body = <Loading />;
      } else {
        body = ConsentingJournalService.createDetailsGrid(this.props);
      }
    }

    const documentGrid = this.createDocumentGrid(documentsMetadata);
    return (
      <div id="consenting-journal">
        <br />
        {documentGrid}
        <br />
        <br />
        {body}
      </div>
    );
  }
}

ConsentingJournalComponent.propTypes = {
  documentsMetadata: PropTypes.array.isRequired,
  consentingGid: PropTypes.string,
  error: PropTypes.object,
  response: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  participantJourneyGid: PropTypes.string,
  fetchParticipantJournal: PropTypes.func
};

export default ConsentingJournalComponent;
